enum Path {
  Home = "/",
  ReturnsPage = "/returns",
}

export default Path;
